module.exports = "./img/7a8dccb6dd92ba1e45a99e6ddaca5b80.jpg";